var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "ptvStatsModal",
        centered: "",
        "hide-footer": "",
        size: _vm.lidarFlag ? "lg" : "xl",
        "header-class": "modal-header-custom",
        "body-class": "modal-body-custom",
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function ({ close }) {
            return [
              _c("div", { staticClass: "modal-title-wrap" }, [
                _c("span", { staticClass: "modal-title-text" }, [
                  _vm._v("Statistic Report"),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "modal-close-btn",
                  on: {
                    click: function ($event) {
                      return close()
                    },
                  },
                },
                [_c("fa", { attrs: { icon: ["fas", "times"] } })],
                1
              ),
            ]
          },
        },
      ]),
    },
    [
      _vm._v(" "),
      _vm.dataLoading
        ? _c("div", { staticClass: "loading-wrap" }, [
            _c("span", {
              staticClass: "spinner-border spinner-border-sm me-2",
              staticStyle: { color: "#4A74A8" },
            }),
            _vm._v(" "),
            _c(
              "span",
              { staticStyle: { color: "#4A74A8", "font-size": "0.9rem" } },
              [_vm._v("Generating Statistics...")]
            ),
          ])
        : _vm.row
        ? _c("div", [
            _c("div", { staticClass: "summary-strip" }, [
              _c("div", { staticClass: "summary-row" }, [
                _c("div", { staticClass: "summary-item" }, [
                  _c("span", { staticClass: "summary-label" }, [
                    _vm._v("Region"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "summary-value" }, [
                    _vm._v(_vm._s(_vm.row.region || "—")),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "summary-divider" }),
                _vm._v(" "),
                _c("div", { staticClass: "summary-item" }, [
                  _c("span", { staticClass: "summary-label" }, [_vm._v("ID")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "summary-value" }, [
                    _vm._v(_vm._s(_vm.row.id || "—")),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "summary-divider" }),
                _vm._v(" "),
                _c("div", { staticClass: "summary-item" }, [
                  _c("span", { staticClass: "summary-label" }, [
                    _vm._v("OSM Segments Length"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "summary-value accent" }, [
                    _vm._v(_vm._s(_vm.row["osm_length"] || "0.0 km")),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "summary-divider" }),
                _vm._v(" "),
                _c("div", { staticClass: "summary-item" }, [
                  _c("span", { staticClass: "summary-label" }, [
                    _vm._v("Total Segments Length"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "summary-value accent" }, [
                    _vm._v(
                      _vm._s(
                        _vm.lidarFlag
                          ? _vm.row["trails_length"] || "0.0"
                          : _vm.row["segment_length"] || "0.0"
                      )
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "summary-row summary-row-note" }, [
                _c("div", { staticClass: "summary-item summary-item-full" }, [
                  _c("span", { staticClass: "summary-label" }, [
                    _vm._v("Note"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "summary-value" }, [
                    _vm._v(_vm._s(_vm.row.note || "—")),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { class: _vm.lidarFlag ? "stats-grid-trt" : "stats-grid-dd" },
              [
                !_vm.lidarFlag
                  ? _c("div", { staticClass: "stat-section" }, [
                      _c(
                        "div",
                        { staticClass: "section-header" },
                        [
                          _c("fa", {
                            staticClass: "me-2",
                            attrs: { icon: ["fas", "road"] },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-2" }, [
                            _vm._v(" FA Metrics"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "stat-row" }, [
                        _c("span", { staticClass: "stat-name" }, [
                          _vm._v("Active Construction"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "stat-val" }, [
                          _vm._v(
                            _vm._s(
                              _vm.row["fa_active_construction_length"] ||
                                "0.0 km"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stat-row" }, [
                        _c("span", { staticClass: "stat-name" }, [
                          _vm._v("Compromised Road Condition"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "stat-val" }, [
                          _vm._v(
                            _vm._s(
                              _vm.row["fa_compromised_road_condition_length"] ||
                                "0.0 km"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stat-row" }, [
                        _c("span", { staticClass: "stat-name" }, [
                          _vm._v("Construction Completed (NA)"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "stat-val" }, [
                          _vm._v(
                            _vm._s(
                              _vm.row[
                                "fa_construction_completed_not_acquired_length"
                              ] || "0.0 km"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stat-row" }, [
                        _c("span", { staticClass: "stat-name" }, [
                          _vm._v("Dropped Segments"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "stat-val" }, [
                          _vm._v(
                            _vm._s(
                              _vm.row["dropped_segment_length"] || "0.0 km"
                            )
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "stat-section" },
                  [
                    _c(
                      "div",
                      { staticClass: "section-header" },
                      [
                        _c("fa", {
                          staticClass: "me-2",
                          attrs: { icon: ["fas", "map"] },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "ml-2" }, [
                          _vm._v(" OSM Road Classes"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(
                      _vm.lidarFlag ? this.osmRows.slice(0, 8) : this.osmRows,
                      function (item) {
                        return _c(
                          "div",
                          { key: item.label, staticClass: "stat-row" },
                          [
                            _c("span", { staticClass: "stat-name" }, [
                              _vm._v(_vm._s(item.label)),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "stat-val" }, [
                              _vm._v(_vm._s(_vm.row[item.field] || "0.0 km")),
                            ]),
                          ]
                        )
                      }
                    ),
                  ],
                  2
                ),
                _vm._v(" "),
                !_vm.lidarFlag
                  ? _c("div", { staticClass: "stat-section" }, [
                      _c(
                        "div",
                        { staticClass: "section-header" },
                        [
                          _c("fa", {
                            staticClass: "me-2",
                            attrs: { icon: ["fas", "route"] },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-2" }, [
                            _vm._v(" Road Types"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "stat-row" }, [
                        _c("span", { staticClass: "stat-name" }, [
                          _vm._v("Access Ramp"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "stat-val" }, [
                          _vm._v(_vm._s(_vm.row["ramp_length"] || "0.0 km")),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stat-row" }, [
                        _c("span", { staticClass: "stat-name" }, [
                          _vm._v("Local"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "stat-val" }, [
                          _vm._v(_vm._s(_vm.row["local_length"] || "0.0 km")),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stat-row" }, [
                        _c("span", { staticClass: "stat-name" }, [
                          _vm._v("Interchange"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "stat-val" }, [
                          _vm._v(
                            _vm._s(_vm.row["interchange_length"] || "0.0 km")
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stat-row" }, [
                        _c("span", { staticClass: "stat-name" }, [
                          _vm._v("Non Controlled"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "stat-val" }, [
                          _vm._v(
                            _vm._s(_vm.row["non_controlled_length"] || "0.0 km")
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stat-row" }, [
                        _c("span", { staticClass: "stat-name" }, [
                          _vm._v("Controlled"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "stat-val" }, [
                          _vm._v(
                            _vm._s(_vm.row["controlled_length"] || "0.0 km")
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stat-row" }, [
                        _c("span", { staticClass: "stat-name" }, [
                          _vm._v("Roundabout"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "stat-val" }, [
                          _vm._v(
                            _vm._s(_vm.row["roundabout_length"] || "0.0 km")
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stat-row" }, [
                        _c("span", { staticClass: "stat-name" }, [
                          _vm._v("Turn Maneuver"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "stat-val" }, [
                          _vm._v(
                            _vm._s(_vm.row["turn_maneuver_length"] || "0.0 km")
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.lidarFlag
                  ? _c("div", { staticClass: "stat-section" }, [
                      _c(
                        "div",
                        { staticClass: "section-header" },
                        [
                          _c("fa", {
                            staticClass: "me-2",
                            attrs: { icon: ["fas", "hashtag"] },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-2" }, [
                            _vm._v(" Counts"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "stat-row" }, [
                        _c("span", { staticClass: "stat-name" }, [
                          _vm._v("Split & Merges"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "stat-val" }, [
                          _vm._v(_vm._s(_vm.row["merges_splits_count"] || "0")),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "stat-row" }, [
                        _c("span", { staticClass: "stat-name" }, [
                          _vm._v("Intersections"),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "stat-val" }, [
                          _vm._v(_vm._s(_vm.row["intersection_count"] || "0")),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }